import { NgModule } from '@angular/core';

import { CertemyCommonModule } from 'common/certemy-common.module';
import { ProfileAvatarModule } from 'components/profile-avatar/profile-avatar.module';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { CheckboxModule } from '@certemy/ui-components';
import { SignatureModule } from 'components/signature/signature.module';

import { EmployerRequestComponent } from './employer-request.component';
import { EmployerRequestModalComponent } from './modal/employer-request-modal.component';
import { CertificateRejectModalModule } from 'components/modal-windows/certificate/reject-modal/certificate-reject-modal.module';
import { CertificatesService } from 'services/professional/certificates/certificates.service';

@NgModule({
  imports: [
    CertemyCommonModule,
    ProfileAvatarModule,
    NgbModalModule,
    CheckboxModule,
    SignatureModule,
    CertificateRejectModalModule,
  ],
  exports: [EmployerRequestComponent],
  declarations: [EmployerRequestComponent, EmployerRequestModalComponent],
  providers: [CertificatesService],
})
export class EmployerRequestModule {}
